"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.captureIfThrows = exports.captureException = exports.captureMessage = exports.initComponentErrorReporter = exports.initAppErrorReporter = exports.enrichErrorReports = exports.sentry = void 0;
var tslib_1 = require("tslib");
// This module is used both in App & Component contexts
// In Component context separate Hub is created to avoid interfering with Widget's Sentry
var Sentry = require("@sentry/browser");
var errorHandling_1 = require("@wix/cashier-common/dist/src/utils/errorHandling");
var experimentsService_1 = require("@wix/cashier-common/dist/src/utils/experimentsService");
var Experiment_1 = require("../types/Experiment");
var isMonitoringEnabled_1 = require("./isMonitoringEnabled");
var cloneError_1 = require("./cloneError");
var isEnabled = function () {
    return isMonitoringEnabled_1.isMonitoringEnabled() &&
        !experimentsService_1.experimentsService.isExperimentEnabled(Experiment_1.Experiment.SuspendErrorReporting);
};
exports.sentry = Sentry;
// In App context (iframe) initial window.Sentry is dummy object that subsequently is replaced with
// full-scale Sentry object (when first error occur Sentry bundle is loaded).
// Due to the way webpack bundles `@sentry/browser` (exports.module = Sentry) Sentry variable will
// always point to the dummy implementation, thus we need to manually update it.
// dummy Sentry implementation doesn't have this flag
if (!exports.sentry.SDK_VERSION) {
    exports.sentry.onLoad(function () {
        exports.sentry = window.Sentry;
    });
}
var customSentryHub;
var isInited = false;
var commonSentryConfig = {
    blacklistUrls: [
        // /localhost/i,
        // /webpack-internal/i,
        // Extensions might inject content-scripts into the frame (bypassing our CSP by modifying CSP header on the flight)
        /extensions\//i,
        /^chrome:\/\//i,
    ],
};
exports.enrichErrorReports = errorHandling_1.ignoreIfThrows(function (extras) {
    if (extras === void 0) { extras = {}; }
    if (!isInited) {
        return;
    }
    var userId = extras.userId, version = extras.version, tags = tslib_1.__rest(extras, ["userId", "version"]);
    var client = customSentryHub || exports.sentry;
    client.configureScope(function (scope) {
        if (userId) {
            scope.setUser({ id: userId });
        }
        if (version) {
            scope.addEventProcessor(function (event) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    return [2 /*return*/, (tslib_1.__assign(tslib_1.__assign({}, event), { release: version }))];
                });
            }); });
        }
        scope.setTags(tags);
    });
});
exports.initAppErrorReporter = errorHandling_1.ignoreIfThrows(function (extras) {
    if (isInited) {
        return;
    }
    isInited = true;
    exports.enrichErrorReports(extras);
    exports.sentry.onLoad(function () {
        exports.sentry.init(isEnabled()
            ? commonSentryConfig
            : // in case of App context Sentry is already tracking errors, thus in order to disable it need to override beforeSend
                {
                    beforeSend: function () {
                        return null;
                    },
                });
    });
});
exports.initComponentErrorReporter = errorHandling_1.ignoreIfThrows(function (extras) {
    if (isInited) {
        return;
    }
    isInited = true;
    if (!isEnabled()) {
        return;
    }
    customSentryHub = new Sentry.Hub();
    // passing client to Hub constructor for some reason doesn't work
    customSentryHub.bindClient(new Sentry.BrowserClient(tslib_1.__assign(tslib_1.__assign({}, commonSentryConfig), { dsn: 'https://964c51bf38ca44d3a745de7bd112a92a@sentry.wixpress.com/408', 
        // if error reporter is used in "public" part of cc form (the one that lives inside the Widget's frame)
        // we don't want to catch all the errors on the page that renders Public component, thus we silence integrations
        // and capture exceptions by hand
        defaultIntegrations: [
            new Sentry.Integrations.InboundFilters(),
            new Sentry.Integrations.FunctionToString(),
            new Sentry.Integrations.UserAgent(),
        ] })));
    exports.enrichErrorReports(extras);
});
exports.captureMessage = function (message) {
    if (isEnabled() && isInited) {
        try {
            if (customSentryHub) {
                customSentryHub.run(function (currentHub) {
                    currentHub.captureMessage(message);
                });
            }
            else {
                exports.sentry.captureMessage(message);
            }
        }
        catch (error) {
            console.error("Failed to exec captureMessage", error);
        }
    }
    console.error('Captured message:', message);
};
exports.captureException = function (error, shouldRethrow, messagePrefix) {
    if (shouldRethrow === void 0) { shouldRethrow = true; }
    if (isEnabled() && isInited) {
        try {
            var errorToReport_1 = error;
            if (messagePrefix) {
                errorToReport_1 = cloneError_1.cloneError(error);
                errorToReport_1.message = messagePrefix + " " + errorToReport_1.message;
            }
            if (customSentryHub) {
                customSentryHub.run(function (currentHub) {
                    currentHub.captureException(errorToReport_1);
                });
            }
            else {
                exports.sentry.captureException(errorToReport_1);
            }
        }
        catch (error) {
            console.error("Failed to exec captureException", error);
        }
    }
    console.error('Captured exception:', error);
    if (shouldRethrow) {
        throw error;
    }
};
exports.captureIfThrows = function (fn, messagePrefix) {
    return errorHandling_1.catchIfThrows(fn, function (error) { return exports.captureException(error, true, messagePrefix); });
};
//# sourceMappingURL=errorReporter.js.map